export const MetricsNames = {
    LOADED_PAGE: "loadedPage",
    SIGN_IN: "signIn",
    SIGN_UP: "signUp",
    PURCHASE_DETAILS: "purchaseDetails",
    ADD_PAYMENT_INFO: "add_payment_info",
    BEGIN_CHECKOUT: "begin_checkout",
    ADD_TO_CART: "add_to_cart",
    VIEW_ITEM: "view_item",
    PURCHASE_SUCCESS: "purchase",
    PURCHASE_ERROR: "purchaseFailure",
    PURCHASE_CANCELED: "purchaseCanceled",
    PURCHASE_CONFIRMED: "purchaseConfirmed", // Open Yoco Payment Checkout
    REFUND_REQUESTED: "refundRequested",
    REFUND_PROCESSED: "refundProcessed",
    REFUND_PROCESSED_DETAILS: "refundProcessedDetails",
    GEOCODING_FAILURE: "geocodingFailure",
    FAILURE_POSTING_COMMENT: "failurePostingComment"
}